export function escapeForOnclickArg(value: string | null | undefined): string | null {
  return value != null
    ? value.replace(/\n/g, ' ')
      .replace(/'/g, "\\'")
      .replace(/"/g, "\\'\\'")
    : null;
}
